/* COCO ROSA — Formulario de personalización (app Avis).
   1) Separa las opciones en tres recuadros: las obligatorias, las adicionales (desde el título
      "Adicionales") y "Cuéntanos la historia de tu pedido".
   2) Muestra el texto que escribe la clienta con la tipografía que eligió.
   3) Fotos de referencia: la tarjeta escrita a mano, cada dije adicional y la guía de tallas en los anillos.
      Las fotos se abren en el visor del pie de página (#cocoVisor, data-ampliar). */
(() => {
  if (window.cocoPersonaliza) return;
  window.cocoPersonaliza = true;

  const FOTOS = window.cocoFotos || {};
  const foto = (nombre) => (FOTOS.base || "") + nombre;
  const sinTildes = (s) => s.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase().trim();
  // valor de la opción en Avis → recorte del dije
  const DIJES = {
    a1: "dorado-a1", a2: "dorado-a2", a3: "dorado-a3",
    b1: "dorado-b1", b2: "dorado-b2", b3: "dorado-b3", c1: "dorado-c1",
    "piedra blanca": "plata-blanca", "piedra celeste": "plata-celeste", corazon: "plata-corazon"
  };

  const titulo = (el) => (el.querySelector(".apo-title, .avp-heading, .avp-option-title") || el).textContent.trim();
  const esHistoria = (el) => el.matches(".avp-option") && /historia/i.test(titulo(el));
  const esInicioExtras = (el) => el.matches(".ap-options__heading-container") && /adicional/i.test(titulo(el));

  function grupo(c, nombre) {
    let g = c.querySelector(":scope > .coco-grupo-" + nombre);
    if (!g) { g = document.createElement("div"); g.className = "coco-grupo coco-grupo-" + nombre; }
    return g;
  }

  // ---------- 1 · Tres recuadros ----------
  function agrupar(c) {
    const sueltos = [...c.children].filter((el) => el.matches(".avp-option"));
    if (!sueltos.length) return;
    const base = grupo(c, "base"), extra = grupo(c, "extra"), historia = grupo(c, "historia");
    // orden actual de todas las opciones (las que ya estaban agrupadas y las nuevas)
    const todas = [...c.querySelectorAll(":scope > .avp-option, :scope > .coco-grupo > .avp-option")];
    let enExtras = false;
    todas.forEach((el, i) => {
      if (esHistoria(el)) return historia.appendChild(el);
      const sig = todas[i + 1];
      if (!enExtras && (esInicioExtras(el) || (el.matches(".ap-options__divider-container") && sig && esInicioExtras(sig)))) enExtras = true;
      (enExtras ? extra : base).appendChild(el);
    });
    const ancla = c.querySelector(":scope > .avp-productoption-total-add, :scope > .apo-total-addcharge");
    [base, extra, historia].forEach((g) => { if (g.children.length) c.insertBefore(g, ancla); else g.remove(); });
    c.classList.toggle("coco-agrupado", extra.isConnected || historia.isConnected);
  }

  // ---------- 2 · Vista previa con la tipografía ----------
  function nombreFuente(inp) {
    const v = (inp.value || "").trim();
    if (v && !/select a font/i.test(v)) return v;
    const m = (inp.getAttribute("style") || "").match(/font-family:\s*["']?([^"';,]+)/i);
    return m && !/inherit/i.test(m[1]) ? m[1].trim() : "";
  }
  function vistaPrevia(c) {
    const fuenteInp = c.querySelector(".avp-font-dropdown > input[readonly]");
    if (!fuenteInp) return;
    const fuente = nombreFuente(fuenteInp);
    c.querySelectorAll(".ap-options__text-container input[type='text']").forEach((t) => {
      const caja = t.closest(".ap-options__text-container");
      let vista = caja.querySelector(".coco-vista");
      if (!vista) {
        vista = document.createElement("div");
        vista.className = "coco-vista";
        vista.setAttribute("aria-live", "polite");
        vista.innerHTML = '<span class="coco-vista-label">Así se verá tu grabado</span><span class="coco-vista-texto"></span>';
        caja.appendChild(vista);
      }
      const texto = t.value.trim();
      t.style.fontFamily = fuente ? `"${fuente}", var(--f-body)` : "";
      t.classList.toggle("coco-con-fuente", !!fuente);
      const span = vista.querySelector(".coco-vista-texto");
      span.textContent = texto || "Escribe tu texto";
      span.style.fontFamily = fuente ? `"${fuente}", var(--f-body)` : "";
      vista.classList.toggle("is-vacia", !texto);
      vista.hidden = !fuente;
    });
  }

  // ---------- 3 · Fotos de referencia ----------
  function botonFoto({ img, alt, titulo, texto, clase = "" }) {
    const b = document.createElement("button");
    b.type = "button";
    b.className = "coco-ref " + clase;
    b.dataset.ampliar = img;
    b.dataset.alt = alt;
    b.innerHTML = `<span class="coco-ref-foto"><img src="${img}" alt="" loading="lazy" width="56" height="70"><span class="coco-ref-lupa" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="6"/><path d="m15 15 5 5M10.5 8v5M8 10.5h5"/></svg></span></span><span class="coco-ref-txt"><b></b><small></small></span>`;
    b.querySelector("b").textContent = titulo;
    b.querySelector("small").textContent = texto;
    return b;
  }
  function ponerAntesDeCampo(op, el) {
    const etiqueta = op.querySelector(":scope > .ap-label-tooltip");
    if (etiqueta) etiqueta.after(el); else op.prepend(el);
  }

  function fotosReferencia(c) {
    if (!FOTOS.base) return;
    c.querySelectorAll(".avp-option").forEach((op) => {
      const t = titulo(op);
      // Tarjeta escrita a mano
      if (/dedicatoria/i.test(t) && !op.querySelector(".coco-ref")) {
        ponerAntesDeCampo(op, botonFoto({
          img: foto("coco-tarjeta.jpg"),
          alt: "Tarjeta Coco Rosa con dedicatoria escrita a mano",
          titulo: "Así llega tu tarjeta 💌",
          texto: "Escribimos tu dedicatoria a mano. Toca para verla en grande.",
          clase: "coco-ref-tarjeta"
        }));
      }
      // Dije adicional: fotito en cada opción + foto con todos los dijes
      if (/dije adicional/i.test(t)) {
        let dorado = false;
        op.querySelectorAll("label.avp-pilloptioncheckwrapper").forEach((lab) => {
          const inp = lab.querySelector("input");
          const clave = DIJES[sinTildes(inp?.value || "")];
          if (!clave) return;
          if (clave.startsWith("dorado")) dorado = true;
          if (lab.querySelector(".coco-dije-img")) return;
          const im = document.createElement("img");
          im.className = "coco-dije-img";
          im.src = foto(`coco-dije-${clave}.jpg`);
          im.alt = "";
          im.width = im.height = 44;
          im.loading = "lazy";
          lab.classList.add("coco-con-dije");
          (lab.querySelector(".choice-list-variatnt-title") || lab).prepend(im);
        });
        if (!op.querySelector(".coco-ref") && op.querySelector(".coco-dije-img")) {
          ponerAntesDeCampo(op, botonFoto({
            img: foto(dorado ? "coco-dijes-dorados.jpg" : "coco-dijes-plateados.jpg"),
            alt: dorado ? "Dijes adicionales dorados A1 a C1" : "Dijes adicionales plateados: corazón, piedra blanca y piedra celeste",
            titulo: "Mira los dijes ✨",
            texto: "Toca para verlos todos en grande.",
            clase: "coco-ref-dije"
          }));
        }
      }
    });
  }

  // ---------- 4 · Guía de tallas en los anillos ----------
  function guiaTallas() {
    if (!FOTOS.base || !/^\s*anillos?\b/i.test(FOTOS.producto || "")) return;
    if (document.querySelector(".coco-guia")) return;
    const forma = document.querySelector(".product__info-container product-form, product-info product-form, product-form");
    if (!forma) return;
    const b = document.createElement("button");
    b.type = "button";
    b.className = "coco-guia";
    b.dataset.ampliar = foto("coco-guia-tallas.jpg");
    b.dataset.alt = "Guía de tallas de anillo Coco Rosa: longitud, talla y diámetro interno";
    b.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2.5" y="7.5" width="19" height="9" rx="2"/><path d="M6.5 7.5v3M10 7.5v4.5M13.5 7.5v3M17 7.5v4.5"/></svg><span>Guía de tallas</span><svg class="coco-guia-flecha" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>`;
    forma.after(b);
  }

  function iniciar(c) {
    if (c.dataset.cocoListo) return;
    c.dataset.cocoListo = "1";
    let pendiente = false;
    const repasar = () => {
      if (pendiente) return;
      pendiente = true;
      setTimeout(() => { pendiente = false; agrupar(c); vistaPrevia(c); fotosReferencia(c); }, 0);
    };
    // Avis vuelve a dibujar las opciones al cambiar de variante: se vuelve a agrupar.
    // Solo se vigilan los hijos directos; agrupar() no mueve nada si ya está ordenado, así no hay bucles.
    new MutationObserver(repasar).observe(c, { childList: true });
    c.addEventListener("input", repasar);
    // elegir una tipografía o "Reset to Default" es un clic dentro del formulario
    c.addEventListener("click", () => setTimeout(repasar, 60));
    repasar();
  }

  const buscar = () => { document.querySelectorAll(".avpoptions-container__v2").forEach(iniciar); guiaTallas(); };
  buscar();
  // Avis carga después que la página: esperamos a que aparezca (y dejamos de mirar a los 20 s)
  const espera = new MutationObserver(buscar);
  espera.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => espera.disconnect(), 20000);
})();
